var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileEditBio.jinja');
require('./MemberProfileEditBio.less');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MemberProfileEditBio-buttons-button--cancel': 'cancelEdit',
        'click .MemberProfileEditBio-buttons-button--save': 'saveEdit'
    },

    saveApi: function () {
        return Urls['member:api:member'](this.options.memberId, 'json');
    },

    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'saveApi');

        Base.prototype.initialize.call(this, options);
    },


    saveEdit: function () {
        var $button = this.$('.MemberProfileEditBio-buttons-button--save');

        $button.addClass('Button--loading');

        this.saveXhr = $.ajax({
            url: this.saveApi(),
            method: 'PATCH',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                bio: this.$('textarea').val()
            }),
            success: function (responseData) {

                app.vent.trigger('need-reload', 'my-adg');// refresh my-adg page if it's current underlying page, to update member info block on it

                $button.removeClass('Button--loading');

                //save response to cache, it's important for all popup edit panels, which renders on the fly to show actual data
                //response always contain all profile data up-to-date
                window.app.data.members[this.options.memberId] = responseData;

                window.app.vent.trigger('MemberProfile--updateBio', this.options.memberId);

                this.cancelEdit();
            },
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    alert('Can\'t update bio!');
                }

                console.log('error', arguments);
            },
            context: this
        });
    },


    cancelEdit: function () {
        this.saveXhr && this.saveXhr.abort();

        window.app.vent.trigger('MemberProfileEdit--close', 'bio');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditBio.js
// module id = 203
// module chunks = 0